import { EducationEnum } from "../../Types/Enums/EducationEnum";

export const EDUCATION_CONFIG = [
  { id: EducationEnum.NONE, labels: { 0: "Sin educación formal", 1: "No formal education" } },
  { id: EducationEnum.PRIMARY, labels: { 0: "Primaria", 1: "Primary school" } },
  { id: EducationEnum.SECONDARY, labels: { 0: "Secundaria", 1: "Middle school" } },
  { id: EducationEnum.HIGH_SCHOOL, labels: { 0: "Preparatoria", 1: "High school" } },
  { id: EducationEnum.BACHELORS, labels: { 0: "Licenciatura", 1: "Bachelor's degree" } },
  { id: EducationEnum.MASTERS, labels: { 0: "Maestría", 1: "Master's degree" } },
  { id: EducationEnum.DOCTORATE, labels: { 0: "Doctorado", 1: "Doctorate degree" } },
];